import React from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css'; 
import aboutUs from '../../assets/video/hero.jpg';

const AboutUs = ({ cityData, locationInfo }) => {
    return (
        <section className="about-us-section">
            <div className="about-us-container"> {/* Inner container */}
                {/* Left Column */}
                <div className="about-us-content">
                    <h2 className="about-us-title">
                        Serving {cityData.locationName} and more!
                    </h2>
                    <p className="about-us-description">
                        Save your back! Hire us to get rid of your junk. 
                        <br /><br />
                        We are happy to help with all types of junk removal. 
                    </p>
                    <Link 
                        to={'tel:'+locationInfo.tracking_phone}
                        className="about-us-button"
                        style={{
                            backgroundColor: "rgb(251, 225, 8)",
                            color: "#22448F",
                            padding: "15px 30px",
                            borderRadius: "5px",
                            fontSize: "24px",
                            fontWeight: 700,
                            fontFamily: "'Roboto', sans-serif",
                            display: "inline-block",
                            textDecoration: "none",
                            width: "350px",
                        }}
                    >
                        Call {locationInfo.tracking_phone}
                    </Link>
                </div>

                {/* Right Column */}
                <div className="about-us-image-container">
                    <img
                        src={aboutUs}
                        className="about-us-image"
                        alt='Ulta Movers'
                    />
                </div>
            </div>
        </section>
    );
};

export default AboutUs;
